import icons from './animated-icons'
import lottie from 'lottie-web'
import toggleClass from './utils/toggleClass'
import UI from './utils/UI'
import { addEventListeners } from './utils/events'
import { TweenMax } from 'gsap'

UI({
  component: '.js-accordion',
  button: '.js-accordion-button',
  content: '.js-accordion-content',
  chevron: '.js-accordion-chevron'
}, ({ component, button, content, chevron }) => {
  let contentIsOpen = false

  button.addEventListener('click', evt => {
    evt.preventDefault()
    button.blur()

    toggleClass(button, 'is-open', !contentIsOpen)

    if (contentIsOpen) {
      close()
    } else {
      open()
    }

    contentIsOpen = !contentIsOpen
  })

  const chevronAnimation = lottie.loadAnimation({
    renderer: 'svg',
    loop: false,
    autoplay: false,
    container: chevron,
    animationData: icons['chevron-down']
  })

  addEventListeners(button, 'mouseenter focus', _ => chevronAnimation.play(), false)
  addEventListeners(button, 'mouseleave blur', _ => chevronAnimation.stop(), false)

  function open () {
    content.style.height = 'auto'
    TweenMax.fromTo(content, 0.2, { height: 0 }, { height: content.clientHeight, onComplete: () => { content.style.height = 'auto' } })
  }

  function close () {
    TweenMax.to(content, 0.2, { height: 0 })
  }
})
